import { createContext, ReactNode, useContext } from 'react';

import { useCustomTabs } from './useCustomTabs';

type CustomTabsContextValue = ReturnType<typeof useCustomTabs>;

const CustomTabsContext = createContext<CustomTabsContextValue | null>(null);

export const CustomTabsProvider = ({ children }: { children: ReactNode }) => {
  const value = useCustomTabs();
  return (
    <CustomTabsContext.Provider value={value}>
      {children}
    </CustomTabsContext.Provider>
  );
};

export const useCustomTabsContext = () => {
  const ctx = useContext(CustomTabsContext);
  if (!ctx)
    throw new Error(
      'useCustomTabsContext must be used within CustomTabsProvider'
    );
  return ctx;
};
